<template>
<v-dialog
    v-model="dialog"
    fullscreen
    v-if="variables != null"
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Variables</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickClose"
                >
                    Close
                </v-btn>

                
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <v-card
                v-for="(item, index) in variables"
                :key="index"
                style="margin-top: 15px;"
            >
                <div
                    style="position: absolute; top: 15px; right: 15px;"
                >
                    <v-btn
                        class="mx-2" fab dark small color="primary"
                        v-on:click="onClickCopy(index)"
                    >
                        <v-icon dark>mdi-content-copy</v-icon>
                    </v-btn>
                </div>   

                <v-card-title><span :ref="'copy_src'+index">{{prettyName(item.name)}}</span></v-card-title>
                <v-card-text>
                    <p>{{item.description}}</p>
                    Examples:
                    <ul>
                        <li
                            v-for="(example, exidx) in item.example_values"
                            :key="'ex'+exidx"
                        >
                            {{example}}
                        </li>

                        
                    </ul>
                </v-card-text>
            </v-card>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    props: {
        context: {
            type: String,
            default: function() { return 'manually-sent'; }
        },

        bulk_message_id: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            dialog: false,
            is_valid: true,
            variables: null,
        }
    },

    methods: {

        showDialog()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'LIST: /api/v1/message-patterns/variables',
            
                'params' : {
                        'context': this.context,
                        'bulk_message_id': this.bulk_message_id,
                    },
            
                'on_success': (data) => {

                        this.variables = data.results;

                        this.dialog = true;
                        this.$router.dialog_guard = this.dialogGuard;
                    },
            
                'on_error': 'Unable to complete list variables',
            });
        },

        prettyName(name)
        {
            return "{"+name+"}";
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            
            this.dialog = false;
            next(false);
        },

        onClickClose()
        {
            this.closeDialog();
        },

        onClickCopy(index)
        {
            window.setTimeout(
                () => {
                    let ref ='copy_src'+index;
                    let code_span = this.$refs[ref][0];


                    var range = document.createRange();
                    range.selectNode(code_span);
                    window.getSelection().removeAllRanges(); // clear current selection
                    window.getSelection().addRange(range); // to select text
                    document.execCommand("copy");
                    window.getSelection().removeAllRanges();// to deselect

                    this.onClickClose();
                    this.$rc.snackbar('Variable copied.',1000);

                },
                100
            )
        },

        onClickCopySpecial(text)
        {
            this.$rc.copy(text);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>